document.addEventListener("input", (event) => {
  if (event.target?.id !== "myInput") return;

  const maxSeats = Number(event.target.max || "${item.available_seats}");
  const numericValue = event.target.value.replace(/\D/g, "");
  const updatedValue = numericValue
    ? String(Math.max(1, Math.min(Number(numericValue), maxSeats)))
    : "";

  event.target.value = updatedValue;
  event.target.setAttribute("value", updatedValue);
  console.log("The value changed to:", updatedValue);
});
